// @flow

import _ from 'lodash';

import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { leaveConference } from '../../base/conference/actions';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { AbstractHangupButton } from '../../base/toolbox/components';
import type { AbstractButtonProps } from '../../base/toolbox/components';
import {
    getLocalParticipant,
    kickParticipant,
    PARTICIPANT_ROLE
} from '../../base/participants';

/**
 * The type of the React {@code Component} props of {@link HangupButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    _participants: Object,
    _isModerator: Boolean,
    _conference: Object
};

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractHangupButton<Props, *> {
    _hangup: Function;

    accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
    label = 'toolbar.hangup';
    tooltip = 'toolbar.hangup';

    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this._hangup = _.once(() => {
            sendAnalytics(createToolbarEvent('hangup'));
            // console.log("particpant: ", this.props._participants);
            if (this.props._isModerator) {
                for (const p of this.props._participants['remote']?.values()) {
                    // console.log("particpant: ", p?.id);
                    if (p.id) {
                        APP.store.dispatch(kickParticipant(p.id));
                    }
                };
            }
            this.props.dispatch(leaveConference());

        });
    }

    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        this._hangup();
    }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @param {Props} ownProps - The component's own props.
 * @returns {Object}
 */
function _mapStateToProps(state) {
    const participants = state['features/base/participants'];
    const conference = state['features/base/conference'];
    const isModerator
        = getLocalParticipant(state).role === PARTICIPANT_ROLE.MODERATOR;

    return {
        _participants: participants,
        _isModerator: isModerator,
        _conference: conference
    };
}

export default translate(connect(_mapStateToProps)(HangupButton));

// export default translate(connect()(HangupButton));
